import { HttpContextToken } from '@angular/common/http';

/** Skip global 401/403 redirects (e.g. session validation on bootstrap). */
export const SKIP_AUTH_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);
